<template>
  <auth-page>
    <div slot="content">
      <p>Wachtwoord vergeten? Geen probleem! Vul hieronder je gebruikersnaam of e-mail adres in en je ontvangt een link om je wachtwoord te resetten.</p>
      <br />
      <form @submit.prevent="request()">
        <b-field label="Gebruikersnaam of E-mail adres">
          <b-input v-model="username" />
        </b-field>
        <button class="button big is-info is-fullwidth" type="is-primary">Opvragen</button>
      </form>
    </div>
  </auth-page>
</template>

<script>
import ApiService from "@/common/api.service";
import AuthPage from "../components/AuthPage.vue";
import { USER_REQUEST_PASSWORD } from "@/store/User/action.type"

export default {
  components: { AuthPage },
  name: "RequestPassword",
  data() {
    return {
      username: "",
    };
  },
  methods: {
    async request() {
      let response = await this.$store.dispatch(USER_REQUEST_PASSWORD, this.username)
      if(response.data) {
        this.$buefy.toast.open({
          message: "Je hebt een mail ontvangen",
          type: "is-success",
        });
      } else {
        this.$buefy.toast.open({
          message: "Deze gebruiker lijkt niet te bestaan",
          type: "is-danger",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  left: 50%;
  a {
    color: #fff !important;
  }
}

@media only screen and (max-width: 769px) {
  .back {
    left: 0;
  }
}
.section {
  width: 50%;
  margin: 0 auto;
  flex-direction: column;
  -webkit-transition: width 0.5s;
  transition: width 0.5s;
  padding: 0 40px !important;
  form {
    width: 100%;
  }
}
@media screen and (max-width: 1300px) {
  .section {
    width: 70%;
  }
}
@media screen and (max-width: 1100px) {
  .section {
    width: 100%;
  }
}
@media screen and (max-width: 768px) {
  .section {
    width: 70%;
  }
}
@media screen and (max-width: 600px) {
  .section {
    width: 100%;
  }
}
</style>
